<template>
  <div class="jumpto-container">
    <flyout-menu title="Jump To" :items="menuLinks"></flyout-menu>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { JumpToMenuLink } from "@/types/jumpto-menu";
import FlyoutMenu from "@/components/v2/shared/FlyoutMenu.vue";

const props = defineProps<{ menuItems?: JumpToMenuLink[] }>();

const menuLinks = computed<JumpToMenuLink[]>(() => {
  if (props.menuItems) {
    return props.menuItems?.filter((l: JumpToMenuLink) => l.visible);
  }
  return [];
});
</script>

<style scoped>
.jumpto-container {
  float: right;
  width: 134px;
}
</style>
